<template>
  <Adminlte>
    <div class="box box-primary center-block">
      <div class="box-header with-border">
        <i class="fa fa-bar-chart font-dark"></i><h3 class="box-title">Relatórios - Segmentados - Textuais</h3>
      </div>
      <section v-if="!isRenderingReports" class="content">
        <button @click="renderReports()" type="button" class="btn btn-primary top-btn">Gerar</button>
        <div class="row main-row">
          <div class="col-xs-12 col-md-9 col-lg-9">
            <div class="report-row">
              <button @click="selectAll()" type="button" class="btn btn-default btn-xs">Selecionar todos</button>
              <button @click="clearSelected()" type="button" class="btn btn-default btn-xs">Limpar</button>
              <div v-for="report in reports" :key="report.id" class="checkbox">
                <label>
                  <input v-model="report.isSelected" type="checkbox"> {{ report.title }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-1"></div>
          <div class="col-xs-12 col-md-2">
            <ReportPeriodFilter
              :is-range="viewMode === 'evolution'"
              :show-view-mode="true"
              :view-mode="viewMode"
              :start-year="startYear"
              :end-year="endYear"
              :year="year"
              title="Período"
              @change="onPeriodChange"
            />
          </div>
        </div>
      </section>
      <section v-if="isRenderingReports" class="content">
        <button @click="isRenderingReports = false" type="button" class="btn btn-primary top-btn">Voltar</button>
        <div class="row text-center display-flex">
          <div
            v-for="report in selectedReports"
            :key="report.id"
            :class="viewMode === 'evolution' ? 'col-xs-12' : 'col-xs-12 col-lg-6'"
          >
            <EvolutionTextualReport
              v-if="report.evolutionData"
              :title="report.title"
              :metadata="report.evolutionData.metadata"
              :entries="report.evolutionData.entries"
              :report-type="report.type"
            />
            <component v-else :is="getReportComponent(report)" :data="report.data"></component>
          </div>
        </div>
      </section>
    </div>
  </Adminlte>
</template>

<script>
  import Adminlte from '@/components/template/Adminlte'
  import ReportClient from '@/services/resource_client/report'
  import ReportFormatter from '@/services/report_formatter'
  import TableReport from '../../components/elements/TableReport'
  import ListReport from '../../components/elements/ListReport'
  import EvolutionTextualReport from '@/components/elements/EvolutionTextualReport'
  import ReportPeriodFilter from '@/components/elements/ReportPeriodFilter'
  import { FIRST_AVAILABLE_YEAR, yearsInRange } from '@/constants/report_period'

  export default {
    name: 'SegmentedTextualReports',
    components: { Adminlte, TableReport, EvolutionTextualReport, ReportPeriodFilter },
    data () {
      return {
        isRenderingReports: false,
        currentYear: new Date().getFullYear(),
        firstAvailableYear: FIRST_AVAILABLE_YEAR,
        year: new Date().getFullYear(),
        startYear: 2000,
        endYear: new Date().getFullYear(),
        viewMode: 'snapshot',
        periodType: 'years',
        startDate: `${new Date().getFullYear()}-01-01`,
        endDate: `${new Date().getFullYear()}-12-31`,
        componentsPerType: {
          'table': TableReport,
          'list': ListReport
        },
        reports: [
          { id: 1, title: 'Principais focos de atuação dos parques tecnológicos', uri: 'reports/park-focus-action-in-year', data: {}, type: 'table', isSelected: false },
          { id: 2, title: 'Principais áreas de atuação das empresas', uri: 'reports/company-areas-expertise-in-year', data: {}, type: 'table', isSelected: false },
          { id: 3, title: 'Valor de investimentos do parque tecnológico', uri: 'reports/park-investments-in-year', data: {}, type: 'table', isSelected: false },
          { id: 4, title: 'Origem dos recursos captados para o parque tecnológico, de acordo com a fonte', uri: 'reports/funds-raised-source-in-year', data: {}, type: 'table', isSelected: false },
          { id: 5, title: 'Recursos de projetos de subvenção obtidos pelo parque tecnológico', uri: 'reports/resources-obtained-in-year', data: {}, type: 'table', isSelected: false },
          { id: 6, title: 'O parque tecnológico possui', uri: 'reports/park-has-in-year', data: {}, type: 'table', isSelected: false },
          { id: 7, title: 'Porcentagem de parques tecnológicos que oferecem local próprio para instalação de empresas', uri: 'reports/offers-installation-place-in-year', data: {}, type: 'table', isSelected: false },
          { id: 8, title: 'Em relação às modalidades para instalação de empresas residentes, o parque tecnológico, possui', uri: 'reports/installation-place-model-in-year', data: {}, type: 'table', isSelected: false },
          { id: 9, title: 'De quem é a propriedade do terreno do parque', uri: 'reports/park-land-ownership-in-year', data: {}, type: 'table', isSelected: false },
          { id: 10, title: 'Local onde o parque tecnológico se encontra instalado', uri: 'reports/park-installation-location-in-year', data: {}, type: 'table', isSelected: false },
          { id: 11, title: 'Áreas do parque tecnológico (m²) - Terreno e lotes', uri: 'reports/park-land-areas-in-year', data: {}, type: 'table', isSelected: false },
          { id: 12, title: 'Áreas do parque tecnológico (m²) - Prédios e edificações', uri: 'reports/park-edification-areas-in-year', data: {}, type: 'table', isSelected: false },
          { id: 13, title: 'Relação de parques em operação', uri: 'reports/list-parks-in-operation-stage-in-year', data: {}, type: 'table', isSelected: false },
          { id: 14, title: 'Relação de parques em implantação', uri: 'reports/list-parks-in-implantation-stage-in-year', data: {}, type: 'table', isSelected: false },
          { id: 15, title: 'Relação de parques em planejamento', uri: 'reports/list-parks-in-planning-stage-in-year', data: {}, type: 'table', isSelected: false },
          { id: 16, title: 'Número de empresas por parque tecnológico em operação', uri: 'reports/companies-in-parks-in-operation-stage-in-year', data: {}, type: 'table', isSelected: false },
          { id: 17, title: 'Relação dos parques em operação por natureza jurídica', uri: 'reports/parks-in-operation-stage-by-legal-nature-in-year', data: {}, type: 'table', isSelected: false },
          { id: 18, title: 'Relação dos parques em operação por "Natureza jurídica da entidade gestora administrativa"', uri: 'reports/parks-in-operation-stage-by-administrative-entity-legal-nature-in-year', data: {}, type: 'table', isSelected: false },
          { id: 19, title: 'Relação dos parques em operação por "Natureza jurídica da entidade gestora financeira"', uri: 'reports/parks-in-operation-stage-by-finance-entity-legal-nature-in-year', data: {}, type: 'table', isSelected: false },
          { id: 20, title: 'Relação dos parques em operação que têm incubadora', uri: 'reports/parks-in-operation-stage-having-incubator-in-year', data: {}, type: 'table', isSelected: false },
          { id: 21, title: 'Relação dos parques em operação que têm aceleradora', uri: 'reports/parks-in-operation-stage-having-accelerator-in-year', data: {}, type: 'table', isSelected: false },
          { id: 22, title: 'Relação dos parques em operação que têm relação formal com instituição de ensino superior', uri: 'reports/parks-in-operation-stage-having-higher-education-link-in-year', data: {}, type: 'table', isSelected: false },
          { id: 23, title: 'Relação dos parques em operação que têm relação formal com institutos de pesquisa', uri: 'reports/parks-in-operation-stage-having-research-center-link-in-year', data: {}, type: 'table', isSelected: false },
          { id: 24, title: 'Relação dos parques tecnológicos por focos de atuação', uri: 'reports/parks-by-focus-action-in-year', data: {}, type: 'table', isSelected: false },
          { id: 25, title: 'Relação dos parques tecnológicos que possuem planejamento estratégico', uri: 'reports/parks-having-strategic-planning-in-year', data: {}, type: 'list', isSelected: false },
          { id: 26, title: 'Relação dos parques que estão formalmente associados à instituições', uri: 'reports/parks-which-are-related-to-institutions-in-year', data: {}, type: 'list', isSelected: false },
          { id: 27, title: 'Relação dos parques que possuem certificações', uri: 'reports/parks-which-has-certifications-in-year', data: {}, type: 'list', isSelected: false },
          { id: 28, title: 'Relação dos parques tecnológicos que possuem interação com algum programa de incubação e/ou aceleração', uri: 'reports/parks-having-incubation-acceleration-interaction-in-year', data: {}, type: 'list', isSelected: false },
          { id: 29, title: 'Relação de parques que oferecem incentivos fiscais, creditícios e/ou benefícos às empresas', uri: 'reports/parks-by-incentives-offered-in-year', data: {}, type: 'list', isSelected: false },
          { id: 30, title: 'Relação de empresas âncoras por área de atuação', uri: 'reports/anchor-companies-by-area-in-year', data: {}, type: 'table', isSelected: false },
          { id: 31, title: 'Necessidades futuras para investimentos do parque tecnológico', uri: 'reports/parks-future-investment-needs-in-year', data: {}, type: 'table', isSelected: false },
          { id: 32, title: 'Necessidades futuras para investimentos do parque tecnológico - Parques em Planejamento', uri: 'reports/parks-in-planning-stage-future-investment-needs-in-year', data: {}, type: 'table', isSelected: false },
          { id: 33, title: 'Necessidades futuras para investimentos do parque tecnológico - Parques em Implantação', uri: 'reports/parks-in-implantation-stage-future-investment-needs-in-year', data: {}, type: 'table', isSelected: false },
          { id: 34, title: 'Necessidades futuras para investimentos do parque tecnológico - Parques em Operação', uri: 'reports/parks-in-operation-stage-future-investment-needs-in-year', data: {}, type: 'table', isSelected: false },
          { id: 35, title: 'Quantidade de parques em operação por Estado', uri: 'reports/parks-count-by-state-in-year', data: {}, type: 'table', isSelected: false },
          { id: 36, title: 'Quantidade de parques em operação por Região', uri: 'reports/parks-count-by-region-in-year', data: {}, type: 'table', isSelected: false },
          { id: 37, title: 'Idade dos parques e tempos entre estágios', uri: 'reports/park-ages-in-year', data: {}, type: 'table', isSelected: false },
          { id: 38, title: 'Parques que não confirmaram Informações Gerais', uri: 'reports/list-parks-without-confirmed-general-information-in-year', data: {}, type: 'list', isSelected: false }
        ]
      }
    },
    methods: {
      onPeriodChange (period) {
        this.viewMode = period.viewMode
        this.periodType = period.periodType
        this.year = period.year
        this.startYear = period.startYear
        this.endYear = period.endYear
        this.startDate = period.startDate
        this.endDate = period.endDate
      },
      renderReports () {
        this.isRenderingReports = true
        this.selectedReports.forEach(r => this.renderReport(r.id))
      },
      fetchSnapshotReport (uri) {
        if (this.periodType === 'dates') {
          return ReportClient.getInDateRange(uri, this.startDate, this.endDate)
        }
        return ReportClient.getInYear(uri, this.year)
      },
      renderReport (id) {
        let report = this.reports.find(r => r.id === id)
        this.$set(report, 'evolutionData', null)

        if (this.viewMode === 'evolution') {
          this.renderEvolutionReport(report)
          return
        }

        this.fetchSnapshotReport(report.uri)
          .then(response => {
            report.data = ReportFormatter.textual(response.data, report.title)
            report.isSelected = true
          })
      },
      evolutionYears () {
        if (this.periodType === 'dates') {
          const startYear = new Date(this.startDate).getFullYear()
          const endYear = new Date(this.endDate).getFullYear()
          return yearsInRange(startYear, endYear)
        }
        return yearsInRange(this.startYear, this.endYear)
      },
      renderEvolutionReport (report) {
        const years = this.evolutionYears()
        const requests = years.map(year =>
          ReportClient.getInYear(report.uri, year).then(response => ({
            year: year,
            data: ReportFormatter.textual(response.data, report.title)
          }))
        )

        Promise.all(requests).then(entries => {
          const entryWithMetadata = entries.find(entry => entry.data && entry.data.metadata)
          this.$set(report, 'evolutionData', {
            metadata: entryWithMetadata ? entryWithMetadata.data.metadata : null,
            entries: entries
          })
          report.isSelected = true
        })
      },
      selectAll () {
        this.reports.forEach(function (r) {
          r.isSelected = true
        })
      },
      clearSelected () {
        this.reports.forEach(function (r) {
          r.isSelected = false
        })
      },
      getReportComponent (r) {
        return this.componentsPerType[r.type]
      }
    },
    computed: {
      selectedReports () {
        return this.reports.filter(r => r.isSelected)
      }
    }
  }
</script>

<style scoped>
  .main-row {
    color: white;
  }
  .year-label {
    display: table-cell;
    vertical-align: middle;
    height: 34px;
  }
  .center-inside-col {
    display: table;
    margin: 0 auto;
    font-size: small;
  }
  .report-row {
    background-color: #488ab3;
    box-shadow: 0px 1px 5px #888888;
    padding: 5px;
  }
  .top-btn {
    margin-bottom: 10px;
  }
  .display-flex {
    display: flex;
    flex-wrap: wrap;
  }
  .display-flex > [class*='col-'] {
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// SegmentedTextualReports.vue?a5c33cdc